import React from 'react';
import styles from './SearchInput.module.scss';
import searhicon from '../../../assets/Imagess/glasses-black.svg';
import searhicon1 from '../../../assets/Imagess/greenSearchIcon.svg';
const SearchInput = ({ search = '', setSearch, width }) => {
  return (
    <div className={styles['search-bar']}>
      <div className={styles['search-container']}>
        <img src={searhicon1} className={styles['search-ic']} alt="icon" />
        <input
          className={styles['search-inp']}
          type="text"
          placeholder="بحث"
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          value={search}
          style={{ width: width }}
        />
      </div>
    </div>
  );
};

export default SearchInput;
